import { render, staticRenderFns } from "./VisibilityIcon.vue?vue&type=template&id=aefa96c8&"
import script from "./VisibilityIcon.vue?vue&type=script&lang=js&"
export * from "./VisibilityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports